import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/users/users.scss";
import { Button, FormControl } from "react-bootstrap";
import queryString from "query-string";
import UserTable from "./UserTable";
import axios from "axios";
import { apiHost, encodeQueryData } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import RoleAccessBadge from "../common/roleAccessBadge";

class users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserList: [],
      searchText: "",
      userTypeFilter: "all",
      userTypeCounts: [],
      sortKey: "customerName",
      sortDirection: "asc",
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      totalPages: 1,
    };
    this.customerId = "";
    this.searchTimer = null;
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.customerId = values.customerId || "";
    this.getUsers();
    this.getUserTypeCounts();
  }

  getUsers = async () => {
    const query = encodeQueryData(this.setUsersQueryObject());
    const url = `${apiHost}/api/auth/AllUsers?${query}`;

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const pagination = response.headers.pagination
        ? JSON.parse(response.headers.pagination)
        : {};

      this.setState({
        UserList: response.data || [],
        totalItems: pagination.totalItems || 0,
        totalPages: pagination.totalPages || 1,
        pageNumber: pagination.currentPage || this.state.pageNumber,
      });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  getUserTypeCounts = async () => {
    const query = encodeQueryData({
      customerId: this.customerId,
      SearchString: this.state.searchText,
    });
    const url = `${apiHost}/api/auth/UserCustomerStatusCounts?${query}`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ userTypeCounts: response.data || [] });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  setUsersQueryObject = () => {
    let data = {};
    data.SearchString = this.state.searchText;
    data.customerId = this.customerId;
    data.UserTypeFilter = this.state.userTypeFilter;
    data.PageSize = this.state.pageSize;
    data.PageNumber = this.state.pageNumber;
    data.SortDirection = this.state.sortDirection === "desc" ? "des" : "asc";
    data.SortString = this.getApiSortString(this.state.sortKey);
    return data;
  };

  handleSearch = (searchText) => {
    this.setState({ searchText, pageNumber: 1 }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getUsers();
        this.getUserTypeCounts();
      }, 300);
    });
  };

  handleUserTypeFilter = (userTypeFilter) => {
    this.setState({ userTypeFilter, pageNumber: 1 }, () => this.getUsers());
  };

  handleSort = (sortKey) => {
    this.setState((prevState) => ({
      sortKey,
      sortDirection:
        prevState.sortKey === sortKey && prevState.sortDirection === "asc"
          ? "desc"
          : "asc",
      pageNumber: 1,
    }), () => this.getUsers());
  };

  handlePageSize = (pageSize) => {
    this.setState({ pageSize: parseInt(pageSize), pageNumber: 1 }, () => this.getUsers());
  };

  handlePageChange = (pageNumber) => {
    const nextPage = Math.max(1, Math.min(pageNumber, this.state.totalPages || 1));
    this.setState({ pageNumber: nextPage }, () => this.getUsers());
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-user?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/create-new-user`);
    }
  };

  updateUserAccess = async (user, changes) => {
    this.props.setLoadingPageAction(true);
    try {
      await axios.post(
        `${apiHost}/api/auth/UpdateUserAccess`,
        {
          Id: user.id,
          Status: changes.status || user.status,
          UserType: [changes.userType || user.userType],
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.getUsers();
      this.getUserTypeCounts();
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  handleUserStatusToggle = (user) => {
    const statusText = (user.status || "").toString().toLowerCase();
    const nextStatus = statusText === "active" ? "Disabled" : "Active";
    this.updateUserAccess(user, { status: nextStatus });
  };

  handleUserRoleChange = (user, userType) => {
    this.updateUserAccess(user, { userType });
  };

  getUserTypeFilterCounts = () => {
    return this.state.userTypeCounts.reduce((counts, item) => {
      const key = item.key || item.status;
      counts[key] = item.count;
      return counts;
    }, {
      all: 0,
      User: 0,
      VTDemo: 0,
      "Community Manager": 0,
      SystemAdmin: 0,
      Disabled: 0,
    });
  };

  getApiSortString = (sortKey) => {
    const sortMap = {
      userName: "username",
      customerName: "customer",
      userType: "usertype",
      timeZoneCity: "timezonecity",
      lastLogin: "lastlogin",
      clientIp: "lastip",
      dbUpdated: "updated",
    };

    return sortMap[sortKey] || sortKey || (this.customerId ? "username" : "customer");
  };

  getVisibleUserTypeFilters = (filters) => {
    const normalizedRole = (localStorage.getItem("role") || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");

    if (normalizedRole === "systemadmin") {
      return filters;
    }

    if (normalizedRole === "vtdemo") {
      return filters.filter((filter) =>
        ["all", "User", "Community Manager", "Disabled"].includes(filter.key)
      );
    }

    if (normalizedRole === "communitymanager") {
      return filters.filter((filter) =>
        ["all", "User", "Community Manager", "Disabled"].includes(filter.key)
      );
    }

    return filters.filter((filter) => filter.key === "all");
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const {
      UserList,
      searchText,
      userTypeFilter,
      sortKey,
      sortDirection,
      pageNumber,
      pageSize,
      totalItems,
      totalPages,
    } = this.state;
    const userTypeCounts = this.getUserTypeFilterCounts();
    const normalizedRole = (localStorage.getItem("role") || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    const isSystemAdmin = normalizedRole === "systemadmin";
    const userTypeFilters = this.getVisibleUserTypeFilters([
      { key: "all", label: "All", count: userTypeCounts.all },
      { key: "User", label: "User", count: userTypeCounts.User },
      { key: "VTDemo", label: "VTDemo", count: userTypeCounts.VTDemo },
      { key: "Community Manager", label: "Community Manager", count: userTypeCounts["Community Manager"] },
      { key: "SystemAdmin", label: "SystemAdmin", count: userTypeCounts.SystemAdmin },
      { key: "Disabled", label: "Disabled", count: userTypeCounts.Disabled },
    ]);
    const entryStart = totalItems === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
    const entryEnd = Math.min(pageNumber * pageSize, totalItems);
    const pageSizes = [50, 100, 200];

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Users</title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper user-page">
              <div className="user-page-header">
                <div>
                  <h2>Users</h2>
                  <p>Manage user accounts, customer access, roles, time zones and login activity.</p>
                  {values.customerId && (
                    <a
                      className="user-filter-pill"
                      onClick={() => localStorage.removeItem("customer")}
                      href="/users"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </a>
                  )}
                </div>
                <div className="user-header-actions">
                  <RoleAccessBadge role="CommunityManager" />
                  {isSystemAdmin && (
                    <Button className="user-create-button" variant="primary" onClick={() => this.handleCreateNew()}>
                      <i className="fa fa-plus"></i>
                      Create new
                    </Button>
                  )}
                </div>
              </div>

              <div className="user-toolbar">
                <div className="user-search">
                  <i className="fa fa-search"></i>
                  <FormControl
                    aria-label="Search users"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    placeholder="Search users, customers, email, role, timezone or status"
                    value={searchText}
                  />
                  {searchText && (
                    <button onClick={() => this.handleSearch("")} type="button">
                      <i className="fa fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="user-status-filter" aria-label="User role filter">
                  <span>User role filter</span>
                  <div>
                    {userTypeFilters.map((filter) => (
                      <button
                        className={userTypeFilter === filter.key ? "active" : ""}
                        key={filter.key}
                        onClick={() => this.handleUserTypeFilter(filter.key)}
                        type="button"
                      >
                        {filter.label}
                        <strong>{filter.count}</strong>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="user-table-shell">
                <UserTable
                  UserList={UserList}
                  onRoleChange={this.handleUserRoleChange}
                  onSort={this.handleSort}
                  onStatusToggle={this.handleUserStatusToggle}
                  sortDirection={sortDirection}
                  sortKey={sortKey}
                />
              </div>
              <div className="user-pagination">
                <div>
                  Showing <strong>{entryStart}</strong> to <strong>{entryEnd}</strong> of{" "}
                  <strong>{totalItems}</strong> users
                </div>
                <div className="user-pagination-actions">
                  <label>
                    Rows
                    <select value={pageSize} onChange={(e) => this.handlePageSize(e.target.value)}>
                      {pageSizes.map((size) => (
                        <option key={size} value={size}>{size}</option>
                      ))}
                    </select>
                  </label>
                  <button
                    disabled={pageNumber <= 1}
                    onClick={() => this.handlePageChange(pageNumber - 1)}
                    type="button"
                  >
                    Previous
                  </button>
                  <span>
                    Page <strong>{pageNumber}</strong> of <strong>{totalPages}</strong>
                  </span>
                  <button
                    disabled={pageNumber >= totalPages}
                    onClick={() => this.handlePageChange(pageNumber + 1)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(users);
